import Banner from "../../sections/common/banner";
import { bannerData } from "../../../globals/banner";
import { useEffect } from "react";
import { loadScript } from "../../../globals/constants";

import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaLightbulb,
  FaHandshake,
  FaChartLine,
  FaBullseye,
  FaEye,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import Seo from "../common/Seo";

function AboutUsPage() {
  useEffect(() => {
    loadScript("js/custom.js");
    AOS.init({
      duration: 900,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <>
      <Seo
        title="About DArchTech | Your Trusted Digital Solutions Partner"
        description="Learn more about DArchTech, a digital solutions company focused on innovation, quality, and scalable technology to help businesses grow online."
      />

      <Banner _data={bannerData.about} />

      {/* ABOUT US SECTION */}
      <section className="py-5 bg-light">
        <div className="container" style={{ maxWidth: "1150px" }}>
          {/* WHO WE ARE */}
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="fw-bold text-dark mb-3">Who We Are</h2>
            <p className="text-secondary lh-lg">
              DArchTech is a technology-driven digital solutions company focused
              on helping businesses build, grow, and scale in the digital
              ecosystem. We partner with organizations of all sizes to deliver
              innovative, reliable, and future-ready digital solutions that
              support long-term business growth.
            </p>
            <p className="text-secondary lh-lg">
              Our team combines strategic thinking, creative problem-solving,
              and technical expertise to create digital experiences that add
              real value. We believe in building solutions that are not only
              functional but also meaningful, scalable, and aligned with
              business goals.
            </p>
          </div>

          {/* OUR APPROACH */}
          <div className="row align-items-stretch mb-5">
            {/* LEFT CARD */}
            <div className="col-md-6 mb-4 mb-md-0" data-aos="fade-right">
              <div className="bg-white rounded-4 shadow-sm p-4 h-100 approach-card">
                <h5 className="fw-semibold mb-3" style={{ color: "#13697A" }}>
                  <FaLightbulb className="me-2" style={{ color: "#13697A" }} />
                  Our Approach
                </h5>

                <p className="text-secondary lh-lg mb-3">
                  At DArchTech, we believe that successful digital solutions
                  begin with a deep understanding of our clients’ needs. We take
                  the time to understand your business, audience, and objectives
                  before crafting strategies and solutions tailored to your
                  unique challenges.
                </p>

                <p className="text-secondary lh-lg mb-0">
                  We follow a transparent and collaborative approach throughout
                  every project, ensuring clear communication, defined
                  timelines, and measurable outcomes.
                </p>
              </div>
            </div>

            {/* RIGHT CARD */}
            <div className="col-md-6" data-aos="fade-left">
              <div className="bg-white rounded-4 shadow-sm p-4 h-100 approach-card">
                <h5 className="fw-semibold mb-3" style={{ color: "#13697A" }}>
                  <FaLightbulb className="me-2" style={{ color: "#13697A" }} />
                  How We Work
                </h5>

                <ul className="text-secondary lh-lg ps-3 mb-0">
                  <li>Understand business and objectives</li>
                  <li>Define strategy and roadmap</li>
                  <li>Design, build, and optimize solutions</li>
                  <li>Measure outcomes and scale growth</li>
                </ul>
              </div>
            </div>
          </div>

          {/* VALUES */}
          <div className="mb-5">
            <h2
              className="fw-bold text-dark text-center mb-4"
              data-aos="fade-up"
            >
              What We Stand For
            </h2>

            <div className="row g-4">
              <div className="col-md-6 col-lg-3" data-aos="zoom-in">
                <div className="bg-white h-100 p-4 rounded-4 shadow-sm text-center">
                  <FaHandshake
                    style={{ color: "#12697A" }}
                    size={32}
                    className="mb-3"
                  />
                  <h5 className="fw-semibold text-dark">
                    Client-First Mindset
                  </h5>
                  <p className="text-secondary mt-2">
                    Your goals drive our decisions. We work as an extension of
                    your team to ensure solutions deliver real business impact.
                  </p>
                </div>
              </div>

              <div
                className="col-md-6 col-lg-3"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div className="bg-white h-100 p-4 rounded-4 shadow-sm text-center">
                  <FaLightbulb
                    style={{ color: "#12697A" }}
                    size={32}
                    className="mb-3"
                  />
                  <h5 className="fw-semibold text-dark">
                    Quality & Innovation
                  </h5>
                  <p className="text-secondary mt-2">
                    We focus on high standards, continuous improvement, and
                    adopting modern technologies to deliver reliable results.
                  </p>
                </div>
              </div>

              <div
                className="col-md-6 col-lg-3"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div className="bg-white h-100 p-4 rounded-4 shadow-sm text-center">
                  <FaHandshake
                    style={{ color: "#12697A" }}
                    size={32}
                    className="mb-3"
                  />
                  <h5 className="fw-semibold text-dark">
                    Transparency & Trust
                  </h5>
                  <p className="text-secondary mt-2">
                    Honest communication, realistic commitments, and clear
                    reporting form the foundation of our client relationships.
                  </p>
                </div>
              </div>

              <div
                className="col-md-6 col-lg-3"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <div className="bg-white h-100 p-4 rounded-4 shadow-sm text-center">
                  <FaChartLine
                    style={{ color: "#12697A" }}
                    size={32}
                    className="mb-3"
                  />
                  <h5 className="fw-semibold text-dark">
                    Scalability & Growth
                  </h5>
                  <p className="text-secondary mt-2">
                    Our solutions are designed to evolve with your business,
                    supporting long-term growth and adaptability.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* MISSION & VISION */}
          <div className="row g-4 mb-5">
            <div className="col-md-6" data-aos="fade-up">
              <div className="bg-white p-5 rounded-4 shadow-sm h-100">
                <FaBullseye
                  style={{ color: "#12697A" }}
                  size={34}
                  className="mb-3"
                />
                <h3 className="fw-bold text-dark mb-3">Our Mission</h3>
                <p className="text-secondary lh-lg">
                  To empower businesses with smart, scalable, and
                  result-oriented digital solutions that drive growth,
                  efficiency, and innovation.
                </p>
              </div>
            </div>

            <div className="col-md-6" data-aos="fade-up" data-aos-delay="150">
              <div className="bg-white p-5 rounded-4 shadow-sm h-100">
                <FaEye
                  style={{ color: "#12697A" }}
                  size={34}
                  className="mb-3"
                />
                <h3 className="fw-bold mb-3">Our Vision</h3>
                <p className="lh-lg">
                  To be a trusted digital partner for businesses worldwide by
                  delivering impactful digital experiences and sustainable
                  growth solutions.
                </p>
              </div>
            </div>
          </div>

          {/* INDUSTRIES */}
          <div
            className="mb-5 pt-4 bg-white p-5 rounded-4 shadow-sm"
            data-aos="fade-up"
          >
            <h2 className="fw-bold text-dark text-center my-5">
              Industries We Work With
            </h2>
            <p className="text-secondary text-center lh-lg">
              We collaborate with businesses across all industries, including
              startups, SMEs, enterprises, e-commerce, healthcare, education,
              finance, manufacturing, real estate, technology, and more.
            </p>
            <p className="text-secondary text-center lh-lg">
              No matter the industry, our focus remains the same — delivering
              solutions that solve real problems and create measurable value.
            </p>
          </div>

          {/* CTA */}
          <div
            className="text-center bg-white p-5 rounded-4 shadow-sm"
            data-aos="zoom-in"
          >
            <h2 className="fw-bold mb-3">Let's Grow Together</h2>
            <p className="text-secondary lh-lg mb-2 text-center">
              At DArchTech, we believe in building long-term relationships, not
              just delivering projects. If you're looking for a reliable digital
              partner to support your growth journey, we're here to help.
            </p>
            <div className="text-center mt-4">
              <NavLink
                to="/contact-us"
                className="site-button sx-btn-primary icon"
              >
                Book a Free Consultation
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutUsPage;
